/**
 * @file src/components/AppFooter.tsx
 * Footer matching the navigation shape used by the email-pdf pages — gives
 * users an exit (back to fowix.io), a way to contact support, and a privacy
 * pointer with a one-line data-handling note.
 */

import { Box, Stack, Typography, Link as MuiLink } from '@mui/material'

export const AppFooter = () => (
  <Box
    component="footer"
    sx={{
      mt: 'auto',
      px: { xs: 2, sm: 3 },
      py: 4,
      borderTop: '1px solid',
      borderColor: 'grey.200',
      bgcolor: 'background.paper',
    }}
  >
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={2}
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      justifyContent="space-between"
      sx={{ maxWidth: 1100, mx: 'auto' }}
    >
      <Typography variant="body2" color="text.secondary">
        Sessions auto-expire and images are deleted shortly after — download or
        email your PDF before the timer runs out.
      </Typography>
      <Stack direction="row" spacing={3} sx={{ fontSize: '0.875rem' }}>
        <MuiLink
          href="https://fowix.io"
          underline="hover"
          color="text.secondary"
          sx={{ fontSize: '0.875rem' }}
        >
          fowix.io
        </MuiLink>
        <MuiLink
          href="mailto:support@fowix.io"
          underline="hover"
          color="text.secondary"
          sx={{ fontSize: '0.875rem' }}
        >
          support@fowix.io
        </MuiLink>
        <MuiLink
          href="https://app.fowix.io/webhook-admin"
          underline="hover"
          color="text.secondary"
          sx={{ fontSize: '0.875rem' }}
        >
          Webhooks
        </MuiLink>
      </Stack>
    </Stack>
  </Box>
)
